import { Switch as MuiSwitch, SwitchProps as MuiSwitchProps } from "@mui/material";
import { FormControlLabel, SxProps, Theme, useTheme } from "@mui/material";
import { ReactNode } from "react";

type SwitchProps = MuiSwitchProps & {
  label?: ReactNode;
};

export const Switch = ({ label, ...rest }: SwitchProps) => {
  const theme = useTheme();
  const rootStyle: SxProps<Theme> = {
    fontWeight: theme.typography.fontWeightBold,
  };

  const muiSwitch = <MuiSwitch color="success" sx={{ rootStyle }} {...rest} />;
  return label ? <FormControlLabel control={muiSwitch} label={label} /> : muiSwitch;
};
